import styled from 'styled-components'
import { WrapPageItem } from '../TransactionsList/index.styles';

const WrapDeviceListByAdmin = styled(WrapPageItem)`
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-bottom: 30px;
   .wrap-header{
       display: flex;
       justify-content: space-between;
       align-items: center;
       .wrap-status-device{
            display: flex;
            align-items: center;
            .devices-status{
                display: flex;
                align-items: center;

                &:not(:first-child) {
                    margin-left: 32px;
                }

                .block-status{
                    width: 12px;
                    height: 12px;
                    margin-right: 8px;
                }
                p{
                    color: #313131;
                    letter-spacing: -0.01em;
                    font-family: "Open Sans";
                    font-weight: 600;
                    font-size: 13px;
                    line-height: 18px;
                }
            }

       }
       .wrap-view-type{
            display: flex;
            justify-content: flex-end;
            gap: 20px;

            .btn-header{
                background: transparent;
                color: #33ADFF;
                padding: 0;
            }
            .wrap-view-active{
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 6px;
                position: relative;

                .total-device-checkbox{
                    font-weight: 600;
                    font-size: 13.5px;
                    line-height: 18px;
                    letter-spacing: -0.01em;
                    color: #313131;
                }
                .icon{
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    svg{
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }
        
    }
`;

export {
    WrapDeviceListByAdmin
}